import { SubmissionError } from 'redux-form';
import { useLocation } from 'react-router-dom';

import { user } from 'services';
import { LangSelector, ThemeChanger } from 'libs/ui';
import { LoginForm } from './form';
import { Content, Line } from './auth.styled';

export const Auth = () => {
  const location = useLocation();
  const referrer = location.state?.referrer;

  /**
   * login
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    return user.login(values, referrer ?? '/').catch((error) => {
      throw new SubmissionError({
        _error: error,
      });
    });
  };

  return (
    <Content>
      <img src="/images/auth-logo.png" alt="CLEVER PARK" />
      <Line>
        <ThemeChanger withBg />
        <LangSelector />
      </Line>
      <LoginForm onSubmit={submit} />
    </Content>
  );
};
